<template>
  <div v-if="loaded">
    <siteNav v-if="showTitle" />
    <div class="layout">
      <router-view />
    </div>
    <Footer v-if="showTitle" />
  </div>
</template>

<script>
// import Header from '@/components/Header';
import qs from "qs";
import { mapState } from "vuex";
import Footer from "@/components/footer";
import siteNav from "@/components/siteNav";

export default {
  name: "App",
  components: {
    Footer,
    // Header,
    siteNav,
  },
  data() {
    return {
      loaded: false,
      isShow: true,
    };
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
    userIdentity: (state) => state.app.userIdentity,
  }),
  async created() {
    await this.$store.dispatch("app/apiInit").then(() => {
      const { ID } = this.userIdentity;
      // 查询供应员权限
      this.$store
        .dispatch("app/roleCheck", {
          roleId: "20181012000002022",
          enterpriseId: ID,
        })
        .then((data) => {
          const { issuccess } = data;
          this.$store.commit("app/setSalesAuthority", issuccess);
        });

      // 查询采购员权限
      this.$store
        .dispatch("app/roleCheck", {
          roleId: "20181012000002021",
          enterpriseId: ID,
        })
        .then((data) => {
          const { issuccess } = data;
          this.$store.commit("app/setPurchaseAuthority", issuccess);
        });

      // 商城支付
      this.$store
        .dispatch("app/roleCheck", {
          roleId: "20181012000002028",
          enterpriseId: ID,
        })
        .then((data) => {
          const { issuccess } = data;
          this.$store.commit("app/setStorePay", issuccess);
        });
    });

    const { pathname } = window.location;
    this.$store.dispatch("shop/shop/getEnterpriseList").then(() => {
      // 客户端下不校验权限
      const { userAgent } = window.navigator;
      if (pathname.indexOf("/mj/") !== -1 && !/qlw-app/.test(userAgent)) {
        let iframeUrl = "";
        if (window.self !== window.top) {
          window.parent.postMessage(
            {
              fn: "getUrl",
            },
            "*"
          );

          window.addEventListener("message", function (e) {
            const {
              data: { url },
            } = e.data;
            iframeUrl = qs.parse(url.split("?")[1]);
          });
        }

        this.$store
          .dispatch("app/getMenuCheck", {
            nameUrl: self != top ? iframeUrl.split("?")[0] : window.location.href.split("?")[0],
          })
          .then((res) => {
            this.loaded = true;
            const { code } = res;
            if (code === "501001") {
              this.$router.push("/power?isShowTitle=1");
            }
          });
      } else {
        this.loaded = true;
      }
    });

    // eslint-disable-next-line window.self !== window.top self != top
    const { query, meta } = this.$route;
    const { isShowTitle } = query;
    if (self != top || isShowTitle || meta.inIframe) {
      this.$store.commit("app/setShowTitle", false);
    } else {
      this.$store.commit("app/setShowTitle", true);
    }
  },
};
</script>
